"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Styles = {
    playPauseBtn: (imageUrl) => core_1.css `
    background-image: ${`url(${imageUrl})`};
  `,
    expanderBtn: (imageUrl) => core_1.css `
    background-image: ${`url(${imageUrl})`};
  `,
    videoWrapper: (fullScreen) => core_1.css `
    ${fullScreen ? 'position: fixed; height: 100%; left: 0; top: 0; background-color: black; flex-direction: row' : ''}
  `,
    controlsCont: (fullScreen) => core_1.css `
    @media (max-width: ${styles_scss_1.default.mobileBreakpoint}) {
      bottom: ${fullScreen ? '25px !important;' : ''};
    }
  `,
    overlay: (open) => core_1.css `
    opacity: ${open ? '1' : '0'} !important;
  `
};
exports.default = Styles;
